/* eslint-disable react-hooks/exhaustive-deps */
import { faArrowLeft, faCheck, faExclamation, faPlay, faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect } from 'react'
import CourseProgress from '../CourseList/CourseProgress'
import Projects from '../CourseList/Projects'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import constants, { videoThumbnail } from '../../utilities/constants'
import { selectAuthentication } from '../../redux/authenticationSlice'
import { Mixpanel } from '../../config/Mixpanel'
import LearnTubeXIllustartion from '../../components/LearnTubeXIllustartion'
import { selectBottomIllustationStatus } from '../../redux/bottomIllustration'
import { selectSubscriptionStatus } from '../../redux/subscriptionStatusSlice'
import { selectModalStatus } from '../../redux/lessonQuizSlice'


const OverView = ({ showOverview, setShowOverview, courseName, courseModule, lessonId, module_slug, setShowQuizCompletionModal }) => {

    const authentication = useSelector(selectAuthentication)
    const bottomIllustrationStatus = useSelector(selectBottomIllustationStatus)
    const subscriptionStatus = useSelector(selectSubscriptionStatus)
    const showQuizModal = useSelector(selectModalStatus)
    
    const navigate = useNavigate()
  
    useEffect(() => {
        Mixpanel.track(constants.Mixpanel.OVERVIEW_PAGE)
    },[])
    
    const truncate = (string = "") => {
        return string.substring(0, 55) + "..."
    }
    
    const handleClick = (index, lessonName) => {
        Mixpanel.track(constants.Mixpanel.OVERVIEW_PAGE_LESSON_WAS_CLICKED)
        const moduleIndex = courseModule?.course_data?.findIndex((item) => item.module_slug === module_slug)
        const moduleContainLesson = courseModule?.course_data?.[moduleIndex]?.module_content?.some((item) => item?.lesson_slug === lessonName)
        if (showQuizModal && !moduleContainLesson && index > moduleIndex){
            setShowQuizCompletionModal(true)
        }else{
            setShowOverview(prev => !prev)
            navigate(`/${encodeURIComponent(courseName)}/${courseModule?.course_data?.[index]?.module_slug}/${lessonName}`)
        }
    }

    function formatTime(seconds) {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
      
        let formattedTime = '';
      
        if (hours > 0) {
          formattedTime += hours + ' hr ';
        }
      
        if (minutes > 0) {
          formattedTime += minutes + ' min';
        }
      
        return formattedTime.trim();
    }

    return (
        <div className='p-4 text-white'>
            <div className='flex justify-between items-center'>
                <div className='flex items-center cursor-pointer' onClick={() => {
                    navigate(`/${encodeURIComponent(courseName)}`)
                    setShowOverview(!showOverview)
                }}>
                    <FontAwesomeIcon icon={faArrowLeft}/>
                    <p className='font-semibold ml-2'>Go to Dashboard</p>
                </div>
                <FontAwesomeIcon icon={faXmark} className='text-3xl font-medium cursor-pointer' onClick={() => setShowOverview(!showOverview)}/>
            </div>
            <div className='text-center mt-4 mb-5'>
                <h2 className='text-2xl font-semibold'>{courseName}</h2>
                {/* <div className='flex items-center justify-center mt-4'>
                    <p className='text-sm font-medium mr-2'>Course is saved until</p>
                    <p className='text-[10px] font-extrabold text-[#E06064] rounded border-[1.4px] border-[#E06064] py-1 px-1.5'>{epochToCustomFormat(createdAt/1000)}</p>
                </div> */}
            </div>
            <div>
                <CourseProgress
                    courseModule={courseModule}
                />
            </div>
            <div className='mt-3'>
                {courseModule?.course_data?.map((item, index) => (     
                    <div key={index} className='relative mb-2 flex flex-col items-end rounded-xl border border-white/10 bg-gradient-to-br from-[#17395A] to-[#102D47]'>
                        <div className='w-[85%] flex-1 mt-3 pr-2'>
                            <div className='pb-5 relative'>
                                <h2 className='text-xl font-semibold leading-[23px]'>{item?.module_name?.length > 60 ? truncate(item?.module_name) : item?.module_name}</h2>
                                <div className='flex items-center'>
                                    <p className='opacity-50 text-sm'>{item?.module_content?.length} Lessons</p>
                                    <div className='mx-2 h-1 w-1 rounded-full bg-[#8FB0CB]'></div>
                                    <p className='opacity-50 text-sm'>{item?.module_duration ? formatTime(item?.module_duration) : formatTime(item?.module_content?.length * 15*60)}</p>
                                </div>
                                <div className={`absolute -left-10 top-2 z-20 flex h-7 w-7 items-center justify-center rounded-full ${item?.module_progress === 0 ? 'bg-[#7897B1]' : 'bg-[#54A3F5]'}`}>
                                    {item?.module_progress === 100 ? <FontAwesomeIcon icon={faCheck} className='font-extrabold'/> : null}
                                </div>
                                <div className={`absolute -left-[28.5px] top-3 z-10 h-[115%] w-[6px] ${item?.module_progress > 0 ? 'bg-[#54A3F5]' : 'bg-[#7897B1]'}`}></div>
                            </div>
                            {item?.module_content?.map((lesson, indexNo) => (
                                <div key={indexNo} className={`flex mb-6 items-center relative cursor-pointer`} onClick={() => {if(!item?.is_locked) handleClick(index, lesson?.lesson_slug)}}>
                                    <img src={item?.is_locked ? videoThumbnail[indexNo < 10 ? indexNo : Math.floor(Math.random() * 10)] : lesson?.thumbnail_url} width={68} height={46} alt="" className={`${item?.is_locked ? 'locked' : ''} ${lesson?.lesson_status === 'completed' && 'blur-[2px]'} ${(lesson?.lesson_status === 'ongoing' || lesson?.lesson_status === 'inprogress' || lesson?.lesson_status === 'quizpending') && 'border-2 border-[#F59E0B]'} ${lesson?.lesson_status === '' && 'opacity-50'} rounded-lg`}/>
                                    <p className={`leading-[17px] text-sm ml-3 ${item?.is_locked ? 'locked' : ''} ${lessonId === lesson?.lesson_id ? 'font-semibold' : 'opacity-50'}`}>{lesson?.lesson_name}</p>
                                    <div className={`absolute z-20 flex h-5 w-5 items-center justify-center rounded-full ${lessonId === lesson?.lesson_id ? 'bg-[#00C838]' : lesson?.lesson_status === "ongoing" || lesson?.lesson_status === "inprogress" || lesson?.lesson_status === "quizpending" ? 'bg-[#F59E0B] shine' : lesson?.lesson_status === "completed" ? 'bg-[#54A3F5]' : 'bg-[#7897B1]'} -left-9`}>
                                        {lessonId === lesson?.lesson_id ? <FontAwesomeIcon icon={faPlay} className='text-sm ml-0.5'/> : lesson?.lesson_status === "ongoing" || lesson?.lesson_status === "inprogress" || lesson?.lesson_status === "quizpending" ? <FontAwesomeIcon icon={faExclamation} className='font-extrabold text-sm'/> : lesson?.lesson_status === "completed" ? <FontAwesomeIcon icon={faCheck} className='font-extrabold text-sm'/> : null
                                        }
                                    </div>
                                    {indexNo < item?.module_content?.length - 1 && <div className={`absolute -left-[30px] top-[60%] z-10 h-[130%] w-[6px] ${lesson?.lesson_status === "" ? 'bg-[#7897B1]' : 'bg-[#54A3F5]'}`}></div>}
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
            {courseModule?.course_projects?.length > 0 && <Projects
                courseName={courseName}
                courseProjects={courseModule?.course_projects}
                showOverview={showOverview}
                setShowOverview={setShowOverview}
            />}
            {subscriptionStatus?.type === 'course_purchased' || bottomIllustrationStatus?.show_banner ? <div className='mt-5'>
                <LearnTubeXIllustartion
                    authentication={authentication}
                />
            </div> : null}
        </div>
    )
}

export default OverView
